module.exports = __webpack_public_path__ + "media/images/icons/moderator-b97cf87cd61261f8e5cd80b04fe1d39f.svg";